import requestAction from '../../utils/requestAction'

export const fetchLogisticWarnings = (params: string) =>
  requestAction('LOGISTIC_WARNING_LIST', params)(`logisticWarnings`, 'GET')
